/**
 * description 视频弹窗控制器
 * created by ge.yuankai
 * created on 2018-04-17
 */
'use strict';
angular.module('insertVideoModule', []).controller('insertVideoCtrl', [
    '$scope',
    '$q',
    '$modalInstance',
    'httpService',
    'modalDialog',
    function ($scope,
        $q,
        $modalInstance,
        httpService,
        modalDialog,
    ) {
        initStatus();
        /**
         * [initStatus description] 初始化参数
         */
        function initStatus() {
            $scope.srcVideo = '';
            $scope.status = {
                videosData: [], //视屏数据的集合
                progress: 0, //上传进度
                libType_v: 101, //视屏的libType,
                uploadSuccess: false, //视频是否上传成功
                uploadError: false, //视频是否上传失败
                // transcoding: false, //视频正在转码
                // transcodSuccess: false, //视屏是否转码成功
                // transcodError: false, //视频是否转码失败
                videoUrl: '', //视屏的播放地址
                uploadVideoUrl: '', //媒资的视频上传接口
                registerVideoInfo: '',
                uploading:false, // 是否正在上传
            };
            $scope.onuploadList = [];
            $scope.uploader = {
                example: '',
                canNotPlay: false, // video标签只能播放MP4、WebM、Ogg的格式
                progress: 0,
                // fastVideoTimer: '',
                // fastVideoInfo: {}, // 视频快编信息
                // speed: '0KB/S', // 上传速率
                // surplusTime: '', // 剩余时间
                uploaderOptions: {
                    showModal: false, // 是否展示弹窗
                    auto: true, // 自动上传
                    multiple: true,
                    accept: {
                        title: '视频',
                        extensions: 'mp4,mov,mpeg,avi',
                        mimeTypes: 'video/mp4,video/mpeg,video/x-msvideo,video/quicktime'
                    },
                    fileSingleSizeLimit: 300 * 1024 * 1024,
                } // 上传配置项
            };
            $scope.data = {};
        }

        $scope.cancel = function () {
            $modalInstance.dismiss();
            $scope.deletevideo();
        };

        /**
         * [uploadVideo description]初始化上传至吉木萨尔县在线的视频的方法
         * @return {[type]} [description]
         */
        $scope.uploadVideo = function () {
            uploadVideo();
        };

        /**
         * [uploadVideo description]视频上传
         * @return {[type]} [description]
         */

        function uploadVideo() {
            var upload = $scope.uploader.example();
            $scope.uploadObj = upload;
            $scope.uploader.canNotPlay = false;
            upload.on('success', function (file) {
                // $scope.status.transcoding = true;
                registerVideo(file).then(videoInfo => {
                    if (file.type !== 'video/mp4') {
                        $scope.uploader.canNotPlay = true;
                    }
                    $scope.status.uploadSuccess = true;
                    $scope.status.uploadError = false; //视频是否上传失败
                    $scope.status.uploading = false; // 正在上传结束
                    // $scope.status.transcoding = false; //视频正在转码
                    // $scope.status.transcodSuccess = true;
                    $scope.status.videosData = [];
                    $scope.status.videosData.push(file);
                    if (file.path && file.path.split('?').length) {
                        $scope.status.videosData[0].url = file.path.split('?')[0];
                    }
                    else {
                        $scope.status.videosData[0].url = file.path;
                    }
                    // $scope.status.videosData[0].url = file.path;
                    $scope.status.videosData[0].videoid = videoInfo.datas.videoid;
                });
            });
            upload.on('progress', function (obj) {
                for (let i = 0; i < $scope.onuploadList.length; i++) {
                    if ($scope.onuploadList[i].id === obj.id) {
                        $scope.status.progress = obj.progress.toFixed(2);
                        $scope.status.speed = obj.speed;
                        if (obj.file.status === '等待上传中') {
                            $scope.status.status = '正在上传中...';
                            $scope.status.canSaveMaterial = false;
                        }
                        if (obj.progress === $scope.status.complete) {
                            $scope.status.status = '正在校验中...';
                            $scope.status.canSaveMaterial = false;
                        }
                        // $scope.status.uploadSuccess = false;
                        // $scope.status.uploadError = false; //视频是否上传失败
                        // $scope.status.transcoding = true; //视频正在转码
                        break;
                    }
                }
            });
            upload.on('fail', function (info) {
                $scope.uploader.progress = 0;
                $scope.status.uploadSuccess = false;
                $scope.status.uploadError = true; //视频是否上传失败
                $scope.status.uploading = false; // 正在上传结束
                // $scope.status.transcoding = false; //视频正在转码
                $scope.deletevideo(info);
            });
            // 上传文件的时候传过来进行分片计算是否展示需要进行文件校验等待
            upload.on('queued', function (file) {
                let fileName = angular.copy(file.file.name);
                $scope.status.uploadNum++;
                $scope.status.uploading = true;
                file.file.fileName = fileName.substring(0, fileName.lastIndexOf('.'));
                $scope.onuploadList.push(file.file);
                $scope.status.status = '等待上传中';
                // $scope.status.uploadSuccess = false;
                // $scope.status.uploadError = false; //视频是否上传失败
                // $scope.status.transcoding = false; //
                $scope.status.canSaveMaterial = false;
                $scope.status.progress = 0;
            });
        }

        /**
         * [registerVideo description]是上传视频后注册视频
         * @param   {[obj]}  file   [file description]上传后的文件
         * @param   {[obj]}  user   [user description]当前用户登录信息
         * @param   {[str]}  token  [token description]用户token
         * @return  {[promise]}         [return description]promise
         */
        function registerVideo(file) {
            var defer = $q.defer();
            var params = {
                tempUrl: file.path,
                tenantId: '3',
                userId: 'AAAABQAMdGVzdEB0cnMuY29tABx0ZXN0QHRycy5jb20sMywxNTc4ODg4Nzg1Nzk4AAAALzAtAhUAkYbTEsbpfqXrVG9_psU_CpwT5lkCFFw1Gq_Hk3yYL89R0fi3yw9f8koN',
                videoName: file.name
            };
            httpService.http('/transfer/aav/video/uploadByTempUrl', params, 'post').then(
                function (data) {
                    defer.resolve(data);
                },
                error => {
                    defer.reject(error);
                }
            );
            return defer.promise;
        }

        $scope.deletevideo = function () {
            $scope.status.progress = 0; //上传进度清零
            $scope.status.uploadSuccess = false; //视频是否上传成功
            $scope.status.uploadError = false; //视频是否上传失败
            $scope.status.uploading = false; // 正在上传结束
            // $scope.status.transcoding = false; //视频正在转码
            // $scope.status.transcodSuccess = false; //视屏是否转码成功
            // $scope.status.transcodError = false; //视频是否转码失败
            $scope.status.videoUrl = ''; //视屏的播放地址
            $scope.status.videosData = [];
            if($scope.uploadObj) { // 存在uploadObj在清楚
                $scope.uploadObj.removeFile($scope.onuploadList[0]);
            }
        };
        /**
         * [confirm] 确认
         * @return {[type]} [description]
         */
        $scope.confirm = function () {
            if ($scope.status.uploading) {
                modalDialog.alertType('', '视频正在上传中，请等待上传结束', 'warning', 'confirm');
                return;
            }
            // if (!$scope.status.transcodSuccess) {
            //     modalDialog.alertType('', '视频正在处理中，请等待处理结束', 'warning', 'confirm');
            //     return;
            // }
            var data = {
                videoUrl: $scope.status.videosData[0].url,
                filename: $scope.status.videosData[0].title,
                videoid: $scope.status.videosData[0].videoid,
                imgUrl: './images/video_default.png',
                type: 'video'
            };
            $modalInstance.close(data);
            // clearalltimeout();
            $scope.deletevideo();
        };
    }
]);
